function setFixedWidthFromElement(element, usePadding) {
  if(typeof usePadding == 'undefined') {
    usePadding = true;
  }

  const width = parseFloat(getComputedStyle(element).width.replace('px', ''), 10);
  const padding = parseFloat(getComputedStyle(element).paddingLeft.replace('px', ''), 10);
  const newWidth = usePadding ? width + padding : width;

  element.style.width = newWidth + 'px';
}

module.exports = setFixedWidthFromElement;
